<script setup lang="ts">
import BaseMusic from "../BaseMusic.vue";
import { _formatNumber, cloneDeep } from "@/utils";
import bus, { EVENT_KEY } from "@/utils/bus";
import { inject } from "vue";
import { videoLikeApi, videoCollectApi } from "@/api/videos";
import { Toast } from "tdesign-mobile-vue";
import { _stopPropagation } from "@/utils";
import { IconFont } from "tdesign-icons-vue-next";

const props = defineProps({
  isMy: {
    type: Boolean,
    default: () => {
      return false;
    },
  },
  item: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

const position = inject<any>("position");

const emit = defineEmits([
  "update:item",
  "goUserInfo",
  "showComments",
  "showShare",
  "goMusic",
]);

function _updateItem(props, key, val) {
  const old = cloneDeep(props.item);
  old[key] = val;
  emit("update:item", old);
  bus.emit(EVENT_KEY.UPDATE_ITEM, { position: position.value, item: old });
}

const loved = async (e) => {
  _stopPropagation(e);
  const res: any = await videoLikeApi({
    video_id: props.item.video_id,
    affirm: !props.item.has_like,
  });
  if (res.status === 1) {
    setTimeout(() => {
      _updateItem(props, "has_like", !props.item.has_like);
    }, 100);
    if (!props.item.has_like) {
      props.item.like++;
    } else {
      props.item.like--;
    }
  } else {
    Toast(res.message);
  }
};

const collected = async (e) => {
  _stopPropagation(e);
  const res: any = await videoCollectApi({
    video_id: props.item.video_id,
    affirm: !props.item.has_collect,
  });
  if (res.status === 1) {
    setTimeout(() => {
      _updateItem(props, "has_collect", !props.item.has_collect);
    }, 100);
    if (!props.item.has_collect) {
      props.item.collect++;
    } else {
      props.item.collect--;
    }
  } else {
    Toast(res.message);
  }
};

function attention(e) {
  e.currentTarget.classList.add("attention");
  setTimeout(() => {
    _updateItem(props, "isAttention", true);
  }, 1000);
}

function showComments(e) {
  _stopPropagation(e);
  bus.emit(EVENT_KEY.OPEN_COMMENTS, props.item.aweme_id);
}
const iconUrl = "../../assets/icon/font-icon/iconfont.css";
</script>

<template>
  <div class="toolbar mb-[10px]">
    <div class="love mb-[20px]" @click="loved">
      <!-- <div>
        <HeartFilledIcon
          size="45px"
          :style="{ color: item.has_like ? 'red' : '' }"
        />
        <icon-font name="iconfont-icon-heart" :loadDefaultIcons="false" />
      </div> -->
      <icon-font
        name="cps-icon cps-icon-heart"
        :url="iconUrl"
        size="35px"
        :loadDefaultIcons="false"
        :style="{ color: item.has_like ? 'red' : '' }"
      />
      <!-- <div class="iconfont icon-heart" :class="{ loved: item.has_like }"></div> -->
      <span>{{ _formatNumber(item.like) }}</span>
    </div>
    <div class="message mb-[20px]" @click="showComments">
      <!-- <ChatBubble1FilledIcon size="38px" /> -->
      <icon-font
        name="cps-icon cps-icon-chat"
        :url="iconUrl"
        size="35px"
        :loadDefaultIcons="false"
      />
      <span>{{ _formatNumber(item.comments) }}</span>
    </div>
    <!--TODO     -->
    <div class="message mb-[20px]" @click="collected">
      <!-- <StarFilledIcon
        v-if="item.has_collect"
        size="38px"
        style="color: rgb(252, 179, 3)"
      />
      <StarFilledIcon v-else size="38px" /> -->
      <icon-font
        name="cps-icon cps-icon-star"
        :url="iconUrl"
        size="35px"
        :loadDefaultIcons="false"
      />
      <span>{{ _formatNumber(item.collect) }}</span>
    </div>
    <div
      v-if="!props.isMy"
      class="share mb-[20px]"
      @click="() => bus.emit(EVENT_KEY.SHOW_SHARE)"
    >
      <icon-font
        name="cps-icon cps-icon-share"
        :url="iconUrl"
        size="35px"
        :loadDefaultIcons="false"
      />
      <!-- <img
        src="@/assets/img/icon/share-white-full.png"
        alt=""
        class="share-image"
      /> -->
      <span>{{ _formatNumber(item.share) }}</span>
    </div>
    <div
      v-else
      class="share mb-[20px]"
      @click="() => bus.emit(EVENT_KEY.SHOW_SHARE)"
    >
      <img src="@/assets/img/icon/menu-white.png" alt="" class="share-image" />
    </div>
    <BaseMusic />
  </div>
</template>

<style scoped lang="less">
.toolbar {
  //width: 40px;
  position: absolute;
  bottom: 0;
  right: 0.625rem;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .avatar-ctn {
    position: relative;

    @w: 2.8125rem;

    .avatar {
      width: @w;
      height: @w;
      border: 0.1875rem solid white;
      border-radius: 50%;
    }

    .options {
      position: absolute;
      border-radius: 50%;
      margin: auto;
      left: 0;
      right: 0;
      bottom: -5px;
      background: red;
      //background: black;
      width: 1.125rem;
      height: 1.125rem;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 1s;

      img {
        position: absolute;
        width: 0.875rem;
        height: 0.875rem;
        transition: all 1s;
      }

      .yes {
        opacity: 0;
        transform: rotate(-180deg);
      }

      &.attention {
        background: white;

        .no {
          opacity: 0;
          transform: rotate(180deg);
        }

        .yes {
          opacity: 1;
          transform: rotate(0deg);
        }
      }
    }
  }

  .love,
  .message,
  .share {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @width: 2.5rem;

    img {
      width: @width;
      height: @width;
    }

    span {
      font-size: 0.75rem;
    }
  }

  .icon {
    font-size: 2.5rem;
  }

  .loved {
    background: red;
  }
}
</style>
